var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Page } from "../../lib/page-component";
import KnockoutModel from "../../lib/knockout_model";
import '../../components/header';
import '../../components/leftMenu';
import './Supervision.css';
import '../../assets/css/preview.css';
import * as authorization from "../../lib/authorization";
import * as ajax from '../../app-lib/ajax_proxy';
import "../../components/paging";
import preview from '../../lib/preview.js';
//import '../project/Myproject.css';
import '../file/daily.css';
var Preview = preview;
//let projectId2=ko.observable();
var HeaderModel = /** @class */ (function (_super) {
    __extends(HeaderModel, _super);
    function HeaderModel(root) {
        var _this = _super.call(this, '/api/user/audits', root, { pageIndex: 1 }) || this;
        _this.formType = ko.observable('');
        _this.chatLog = ko.observable(false);
        _this.massage = ko.observableArray([]);
        ////////////
        _this.options = ko.observableArray([{ id: 0, text: "全部" }, { id: 1, text: "待审核" }, { id: 2, text: "已审核" }, { id: 3, text: "自动审核" }, { id: 4, text: '已驳回' }]);
        _this.auditStage = ko.observableArray([{ id: 0, text: "全部" }, { id: 1, text: '首次拜访->洽谈跟进' }, { id: 2, text: "洽谈跟进->业绩核算（A）" }, { id: 3, text: "洽谈跟进->业绩核算（B）" }, { id: 4, text: "业绩核算->完成" }, { id: 5, text: "完成" }]);
        _this.selectType = ko.observable('全部'); // 选择的状态类型
        _this.selectStage = ko.observable('全部'); //选择的审核阶段
        _this.projectName = ko.observable(''); //查询的名字
        ////////////
        _this.projectId = ko.observable(); // 项目id
        _this.project = ko.observable(); //待审核出现的框 项目
        _this.projects = ko.observableArray();
        _this.popur = ko.observable(0);
        _this.quanwei = ko.observable(0);
        _this.shougou = ko.observable(0);
        _this.XiangXi = ko.observable(0);
        ///
        _this.showData = ko.observable(0);
        _this.projectStatus = ko.observable();
        _this.userId = ko.observable();
        //	sreason = ko.observable('');
        //greason = ko.observable('');
        _this.isNoShow = ko.observable(true);
        _this.shougouInfo = ko.observable(); // 收购的详细信息
        _this.quanweiInfo = ko.observable(); ///全委的信息
        _this.auditStatus = ko.observable();
        // }
        // 模糊查询项目
        // searchProject() {
        // 	// console.log("===>"+this.projectName());
        // 	this.data = {};
        // 	//this.url="/api/user/Findaudit";
        // 	this.id = null;
        // 	this.data.pageIndex = 1;
        // 	this.data.type = this.selectType();
        // 	this.data.projectName = this.projectName();
        // 	this.data.uid = authorization.getUserId();
        // 	this.data.order='big';
        // 	this.loadData();
        // }
        ////点击审核
        _this.reason = ko.observable(''); //驳回理由
        _this.status = ko.observable(1);
        return _this;
    }
    //加载跟进记录
    HeaderModel.prototype.openlog = function (id) {
        var _this = this;
        this.chatLog(true);
        ajax.get('/api/user/chatMessage', {
            pid: id,
        }).then(function (r) {
            _this.massage(r.data.messages);
            _this.container.querySelector('.daily_scrollxx-height').scrollTop = _this.container.querySelector('.daily_scrollxx-height').scrollHeight;
        });
    };
    HeaderModel.prototype.close = function () {
        this.chatLog(false);
        this.massage([]);
    };
    //是否本人
    HeaderModel.prototype.isMe = function (id) {
        if (id && id == authorization.getUserId()) {
            return true;
        }
        else {
            return false;
        }
    };
    //定位
    HeaderModel.prototype.location1 = function (m, d, e) {
        var mapgps;
        setTimeout(function () {
            // let div = document.getElementById("44444") ;
            mapgps = d.chatMessage.split(',');
            var map = new BMap.Map(e + 'dw' + '');
            map.centerAndZoom(new BMap.Point(mapgps[0], mapgps[1]), 16);
            map.addControl(new BMap.NavigationControl());
            map.addControl(new BMap.ScaleControl());
            map.addControl(new BMap.OverviewMapControl());
            map.addControl(new BMap.MapTypeControl());
            map.enableScrollWheelZoom(true);
            var new_point = new BMap.Point(mapgps[0], mapgps[1]);
            var marker = new BMap.Marker(new_point); // 创建标注
            map.addOverlay(marker); // 将标注添加到地图中
            map.panTo(new_point);
            var i = 16;
            map.addEventListener("click", function () {
                i = i + 1;
                mapgps = d.chatMessage.split(',');
                var map = new BMap.Map(e + 'dw');
                map.centerAndZoom(new BMap.Point(mapgps[0], mapgps[1]), i);
                map.enableScrollWheelZoom(true);
                var new_point = new BMap.Point(mapgps[0], mapgps[1]);
                var marker = new BMap.Marker(new_point); // 创建标注
                map.addOverlay(marker); // 将标注添加到地图中
                map.panTo(new_point);
            });
        }, 1000);
    };
    HeaderModel.prototype.ShouGou = function () {
        if (this.shougou() == 1) {
            this.project(undefined);
            this.shougou(0);
        }
        else {
            this.shougou(1);
        }
    };
    HeaderModel.prototype.QuanWei = function () {
        if (this.quanwei() == 1) {
            this.quanwei(0);
        }
        else {
            this.quanwei(1);
        }
    };
    HeaderModel.prototype.qwZK = function (m, e) {
        var div = e.currentTarget.parentNode.nextElementSibling;
        var div1 = e.currentTarget.firstElementChild;
        if (!div.style.display || div.style.display == "none") {
            div.style.display = 'block';
            div1.style.transform = 'rotate(180deg)';
        }
        else {
            div.style.display = 'none';
            div1.style.transform = 'rotate(0deg)';
        }
    };
    HeaderModel.prototype.open = function () {
        //console.log('1')
    };
    // Popur(e: any, data: any) {
    // 	this.reason('');
    // 	this.projects(this.viewModel()); // 把数据放到projects
    // 	this.projectId(e.id);//获取到项目的id
    // 	this.projectStatus(e.projectStatus);
    // 	this.auditStatus(e.auditStatus);
    // 	this.projectId(e.id)
    // 	document.getElementById("quanwei").setAttribute("style", "display:block");
    // 	document.getElementById("shougou").setAttribute("style", "display:block");
    // 	if (this.auditStatus() == '4' && e.cooperationMode == "收购") {
    // 		this.shougou(1);
    // 		document.getElementById("shougou").setAttribute("style", "display:none");
    // 		ajax.get("/api/audit", { projectId: this.projectId() }).then(d => {
    // 			this.shougouInfo(d.data);
    // 			this.greason(d.data.reason);
    // 		})
    // 		return;
    // 	}
    // 	if (this.auditStatus() == '4' && e.cooperationMode != "收购") {
    // 		document.getElementById("quanwei").setAttribute("style", "display:none");
    // 		this.quanwei(1);
    // 		ajax.get("/api/audit", { projectId: this.projectId() }).then(d => {
    // 			this.quanweiInfo(d.data);
    // 			this.sreason(d.data.reason);
    // 		})
    // 		return;
    // 	}
    // 	// pc端 和app 端 第一阶段 审核
    // 	if (e.projectStatus == '首次拜访') {
    // 		//this.popur(1);
    // 		if (this.popur() == 1) {
    // 			this.popur(0);
    // 		} else {
    // 			this.popur(1);
    // 		}
    // 		ajax.get("/api/project/getonedetail", { id: e.id }).then(d => {
    // 			this.project(d.data.project[0]);
    // 			let photo = document.getElementById("pic");
    // 			if (d.data.project[0].havePhoto != 0) {
    // 				photo.setAttribute("src", d.data.project[0].havePhoto);
    // 				photo.setAttribute("style", "display:block");
    // 			}
    // 		});
    // 		// app端 自动审核 复审
    // 	} else if (e.projectStatus == '洽谈跟进' && e.auditStatus == "3") {
    // 		if (this.popur() == 1) {
    // 			this.popur(0);
    // 		} else {
    // 			this.popur(1);
    // 		}
    // 		ajax.get("/api/project/getonedetail", { id: e.id }).then(d => {
    // 			this.project(d.data.project[0]);
    // 			let photo = document.getElementById("pic");
    // 			if (d.data.project[0].havePhoto != 0) {
    // 				photo.setAttribute("src", d.data.project[0].havePhoto);
    // 				photo.setAttribute("style", "display:block");
    // 			}
    // 		});
    // 		//pc端 和app 端 第一阶段  人工审核 后复审
    // 	} else if (e.projectStatus == '洽谈跟进' && e.auditStatus == "1") {
    // 		if (this.popur() == 1) {
    // 			this.popur(0);
    // 		} else {
    // 			this.popur(1);
    // 		}
    // 		ajax.get("/api/project/getonedetail", { id: e.id }).then(d => {
    // 			this.project(d.data.project[0]);
    // 			let photo = document.getElementById("pic");
    // 			if (d.data.project[0].havePhoto != 0) {
    // 				photo.setAttribute("src", d.data.project[0].havePhoto);
    // 				photo.setAttribute("style", "display:block");
    // 			}
    // 		});
    // 		//  业绩核算驳回到  洽谈跟进
    // 	} else if (e.projectStatus == '洽谈跟进' && (e.auditStatus == "0" || e.auditStatus == "-1" || e.auditStatus == "-2" || e.auditStatus == "-3")) {
    // 		if (e.cooperationMode == '收购') {
    // 			this.shougou(1);
    // 			//this.data = {};
    // 			ajax.get("/api/audit", { projectId: this.projectId() }).then(d => {
    // 				this.shougouInfo(d.data);
    // 				this.greason(d.data.reason);
    // 			})
    // 			return;
    // 		} else if (e.cooperationMode != '收购') {
    // 			this.quanwei(1);
    // 			//this.data = {};
    // 			ajax.get("/api/audit", { projectId: this.projectId() }).then(d => {
    // 				this.quanweiInfo(d.data);
    // 				this.sreason(d.data.reason);
    // 			})
    // 		}
    // 	} else if (e.projectStatus == '完成' || e.projectStatus == '业绩核算') {
    // 		if (e.cooperationMode == '收购') {
    // 			this.shougou(1);
    // 			//this.data = {};
    // 			ajax.get("/api/audit", { projectId: this.projectId() }).then(d => {
    // 				this.shougouInfo(d.data);
    // 				this.greason(d.data.reason);
    // 			})
    // 			return;
    // 		} else if (e.cooperationMode != '收购') {
    // 			this.quanwei(1);
    // 			ajax.get("/api/audit", { projectId: this.projectId() }).then(d => {
    // 				this.quanweiInfo(d.data);
    // 				this.sreason(d.data.reason);
    // 			});
    // 		}
    // 	}
    // 	if (e.auditStatus == null || e.auditStatus == undefined) {
    // 		this.popur(0);
    // 	}
    // 	// if(this.popur()==1){
    // 	// 	this.popur(0);
    // 	// }else{
    // 	// 	this.popur(1);
    // 	// }
    // }
    // XiangXiZK(m: any, e: any) {
    // 	let div = (((e.currentTarget as HTMLElement).parentNode as HTMLElement).parentNode as HTMLElement).nextElementSibling as HTMLElement;
    // 	let div2 = div.nextElementSibling as HTMLElement
    // 	if (!div.style.display || div.style.display == "none") {
    // 		div.style.display = 'block';
    // 		div2.style.display = 'block';
    // 	} else {
    // 		div.style.display = 'none';
    // 		div2.style.display = 'none';
    // 	}
    // }
    HeaderModel.prototype.GengDuo = function (m, e) {
        var div = e.currentTarget.nextElementSibling;
        if (!div.style.display || div.style.display == "none") {
            div.style.display = 'block';
        }
        else {
            div.style.display = 'none';
        }
    };
    ///////
    HeaderModel.prototype.top = function () {
        var pageIndex = this.viewModel().data.pageIndex;
        this.data = {};
        this.id = null;
        this.data.pageIndex = pageIndex;
        this.data.type = this.selectType();
        this.data.type2 = this.selectStage();
        this.data.uid = authorization.getUserId();
        this.data.order = 'small';
        if (this.projectName().trim() == "" || this.projectName() == null) {
            this.data.projectName = "";
        }
        else {
            this.data.projectName = this.projectName();
        }
        // this.url="/api/user/Findaudit";
        this.loadData();
    };
    HeaderModel.prototype.dateTime = function (str) {
        var str1 = str.substr(0, 10);
        var str2 = str.substr(11, 8);
        return str1 + ' ' + str2;
    };
    //smoney=ko.observable('');//收购预计提成总额
    //qmoney=ko.observable('');//全委预计提成总额
    HeaderModel.prototype.look = function (data) {
        var _this = this;
        if (data.status == '-1') {
            return window.popBox.show('还没有提交新的照片');
        }
        if (data.status == '-2') {
            return window.popBox.show('还没有提交新的表单');
        }
        this.projectStatus(data.status);
        this.auditStatus(data.auditStatus);
        this.projectId(data.projectId);
        if (data.status == '6') {
            //	(this.container.querySelector('#quanwei') as HTMLElement ).setAttribute("style", "display:none");
            if (data.projectStatus == '股权合作') {
                ajax.get('/api/audit', {
                    projectId: data.projectId
                }).then(function (d) {
                    d.data.extractList = ko.observableArray(d.data.extractList);
                    d.data.totalExtract = ko.observable(d.data.totalExtract);
                    d.data.extractList().forEach(function (p) { return p.extract = ko.observable(p.extract); });
                    _this.shougouInfo(d.data);
                    //	this.greason(d.data.reason);
                    _this.shougou(1);
                });
            }
            else {
                ajax.get("/api/audit", {
                    projectId: data.projectId
                }).then(function (d) {
                    d.data.extractList = ko.observableArray(d.data.extractList);
                    d.data.totalExtract = ko.observable(d.data.totalExtract);
                    d.data.extractList().forEach(function (p) { return p.extract = ko.observable(p.extract); });
                    _this.quanweiInfo(d.data);
                    //this.sreason(d.data.reason);
                    _this.quanwei(1);
                });
            }
        }
        if (data.status == '0') {
            ajax.get('/api/project/getonedetail', {
                id: data.projectId
            }).then(function (d) {
                ajax.get("/api/project/getonedetail", {
                    id: data.projectId
                }).then(function (d) {
                    _this.project(d.data.project[0]);
                    var photo = _this.container.querySelector('#pic');
                    if (d.data.project[0].havePhoto != 0) {
                        photo.setAttribute("src", d.data.project[0].havePhoto);
                        photo.setAttribute("style", "display:block");
                    }
                    var preview = new Preview({
                        imgWrap: 'picDiv' // 指定该容器里的图片点击预览
                    });
                    _this.popur(1);
                });
            });
        }
    };
    HeaderModel.prototype.edit = function (data) {
        var _this = this;
        this.formType(data.projectStatus);
        this.projectStatus(data.status);
        this.auditStatus(data.auditStatus);
        this.projectId(data.projectId);
        if (data.status == '1') {
            ajax.get("/api/project/getonedetail", {
                id: data.projectId
            }).then(function (d) {
                _this.project(d.data.project[0]);
                var photo = _this.container.querySelector('#pic');
                if (d.data.project[0].havePhoto != 0) {
                    photo.setAttribute("src", d.data.project[0].havePhoto);
                    photo.setAttribute("style", "display:block");
                }
                var preview = new Preview({
                    imgWrap: 'picDiv' // 指定该容器里的图片点击预览
                });
                _this.popur(1);
            });
        }
        else if (data.status == '3' || data.status == '4' || data.status == '5') {
            if (data.projectStatus == '股权合作') {
                //(this.container.querySelector('#shougou')as HTMLElement).setAttribute("style", "display:none");
                ajax.get("/api/audit", {
                    projectId: data.projectId
                }).then(function (d) {
                    d.data.extractList = ko.observableArray(d.data.extractList);
                    d.data.totalExtract = ko.observable(d.data.totalExtract);
                    d.data.extractList().forEach(function (p) { return p.extract = ko.observable(p.extract); });
                    _this.shougouInfo(d.data);
                    console.log(_this.shougouInfo());
                    console.log(_this.shougouInfo().extractList());
                    //	this.greason(d.data.reason);
                    //this.smoney(d.data.totalExtract)
                    _this.shougou(1);
                });
            }
            else {
                ajax.get("/api/audit", {
                    projectId: data.projectId
                }).then(function (d) {
                    d.data.extractList = ko.observableArray(d.data.extractList);
                    d.data.totalExtract = ko.observable(d.data.totalExtract);
                    d.data.extractList().forEach(function (p) { return p.extract = ko.observable(p.extract); });
                    _this.quanweiInfo(d.data);
                    console.log(_this.quanweiInfo().extractList());
                    //	this.qmoney(d.data.totalExtract)
                    //this.sreason(d.data.reason);
                    _this.quanwei(1);
                });
            }
        }
    };
    HeaderModel.prototype.closeedit = function () {
        this.quanweiInfo(undefined);
        this.popur(0);
    };
    HeaderModel.prototype.startsearch = function () {
        this.data.pageIndex = 1;
        this.data.order = 'big';
        this.data.type = this.selectType();
        this.data.type2 = this.selectStage();
        this.data.uid = authorization.getUserId();
        if (this.projectName().trim() == "" || this.projectName() == null) {
            this.data.projectName = "";
        }
        else {
            this.data.projectName = this.projectName();
        }
        this.loadData();
    };
    HeaderModel.prototype.bottom = function () {
        var pageIndex = this.viewModel().data.pageIndex;
        this.data = {};
        this.id = null;
        this.data.pageIndex = pageIndex;
        this.data.order = 'big';
        this.data.type = this.selectType();
        this.data.type2 = this.selectStage();
        this.data.uid = authorization.getUserId();
        if (this.projectName().trim() == "" || this.projectName() == null) {
            this.data.projectName = "";
        }
        else {
            this.data.projectName = this.projectName();
        }
        this.loadData();
    };
    // 状态下拉列表
    HeaderModel.prototype.selectOption = function () {
        var pageIndex = this.viewModel().data.pageIndex;
        //console.log(this.selectType());
        this.data = {};
        this.id = null;
        this.data.type = this.selectType();
        this.data.type2 = this.selectStage();
        this.data.pageIndex = 1;
        //this.data.order='';
        this.data.uid = authorization.getUserId();
        this.data.order = "big";
        if (this.projectName().trim() == "" || this.projectName() == null) {
            this.data.projectName = "";
        }
        else {
            this.data.projectName = this.projectName();
        }
        //this.url="/api/user/Findaudit";	 
        this.loadData().then().catch(function (e) {
            //console.log("下拉列表出错");
        });
    };
    // 审核阶段下拉
    HeaderModel.prototype.stageChange = function () {
        var pageIndex = this.viewModel().data.pageIndex;
        //console.log(this.selectType());
        this.data = {};
        this.id = null;
        this.data.type = this.selectType();
        this.data.type2 = this.selectStage();
        this.data.pageIndex = 1;
        //this.data.order='';
        this.data.uid = authorization.getUserId();
        this.data.order = "big";
        if (this.projectName().trim() == "" || this.projectName() == null) {
            this.data.projectName = "";
        }
        else {
            this.data.projectName = this.projectName();
        }
        //this.url="/api/user/Findaudit";	 
        this.loadData().then().catch(function (e) {
            //console.log("下拉列表出错");
        });
    };
    HeaderModel.prototype.pass = function (e, data) {
        var _this = this;
        if (this.projectStatus() == "洽谈跟进" && (this.auditStatus() == '3' || this.auditStatus() == '1')) {
            return window.popBox.show(" 无法再次审核");
        }
        else {
            var pageIndex_1 = this.viewModel().data.pageIndex;
            this.projects(this.viewModel());
            this.popur(0);
            console.log(this.projectId(), this.projectStatus());
            ajax.post("/api/project/progo", {
                userId: authorization.getUserId(),
                projectId: this.projectId(),
                // austatus: this.auditStatus(), 
                content: this.reason(),
                projectStatus: this.projectStatus()
            }).then(function (d) {
                _this.project(undefined);
                _this.quanweiInfo(undefined);
                // 发送数据重新加载数据
                _this.data = {};
                //this.url="/api/user/Findaudit";
                _this.data.type = _this.selectType();
                _this.data.type2 = _this.selectStage();
                _this.data.pageIndex = pageIndex_1;
                _this.data.name = _this.projectName();
                _this.data.uid = authorization.getUserId();
                _this.data.order = 'big';
                _this.loadData();
            });
        }
    };
    ////点击 驳回
    HeaderModel.prototype.back = function (data) {
        var _this = this;
        var pageIndex = this.viewModel().data.pageIndex;
        this.popur(0);
        ajax.post("/api/project/proback", {
            uid: authorization.getUserId(),
            pid: this.projectId(),
            prostatus: this.projectStatus(),
            content: this.reason(),
            austatus: this.auditStatus()
        })
            .then(function (d) {
            _this.project(undefined);
            _this.quanweiInfo(undefined);
            // 发送数据重新加载数据
            _this.data = {};
            //this.url="/api/user/Findaudit";
            _this.data.type = _this.selectType();
            _this.data.type2 = _this.selectStage();
            _this.data.uid = authorization.getUserId();
            _this.data.name = _this.projectName();
            _this.data.pageIndex = pageIndex; // 保存当前页
            _this.data.order = 'big';
            _this.loadData();
        });
    };
    ///// 收购的审核
    HeaderModel.prototype.shougouPass = function (data) {
        var _this = this;
        if (this.auditStatus() == "4") {
            window.popBox.show("复审同意后不能驳回");
            return;
        }
        if (this.shougouInfo().totalExtract() == 0) {
            this.shougouInfo().totalExtract(Number(this.shougouInfo().totalExtract()).toFixed(2));
            console.log('-------新津女子图鉴1--------');
        }
        if (this.shougouInfo().totalExtract() == '') {
            return window.popBox.show('金额不能为空');
        }
        if (Number(this.shougouInfo().totalExtract()) < 0) {
            return window.popBox.show('金额不能小于0');
        }
        if (Number(this.shougouInfo().totalExtract()) >= 100000000000000000000) {
            return window.popBox.show('金额过大');
        }
        if (this.shougouInfo().reason.length > 400) {
            window.popBox.show('审核意见不能超过400个字符');
            return;
        }
        for (var i in this.shougouInfo().extractList()) {
            var n = this.shougouInfo().extractList()[i];
            if (n.comment && n.comment.length > 400) {
                return window.popBox.show('备注字符不能超过400');
            }
            if (n.assignRate == '') {
                return window.popBox.show('分配比例不能存在空值');
            }
            if (Number(n.assignRate) < 0) {
                return window.popBox.show('分配比例不能小于0');
            }
        }
        if (this.projectStatus() == "完成") {
            window.popBox.show("已经审核不能再点击审核");
        }
        else if (this.projectStatus() == "洽谈跟进" && (this.auditStatus() == "0" || this.auditStatus() == "-1" || this.auditStatus() == "-2" || this.auditStatus() == "-3")) {
            window.popBox.show("业务员还没有上传表单");
        }
        else {
            if (this.sumOfComputation()) {
                this.shougouInfo().extractList().map(function (p) { return _this.toJS(p); });
                ajax.post('/api/update/signform', this.toJS(this.shougouInfo())).then(function () {
                });
                var pageIndex_2 = this.viewModel().data.pageIndex;
                this.projects(this.viewModel());
                this.shougou(0);
                console.log(this.projectId(), this.projectStatus());
                ajax.post("/api/project/progo", {
                    userId: authorization.getUserId(),
                    projectId: this.projectId(),
                    austatus: this.auditStatus(),
                    content: this.shougouInfo().reason,
                    projectStatus: this.projectStatus()
                }).then(function (d) {
                    window.popBox.show(d.message).then(function () {
                        // 发送数据重新加载数据
                        _this.data = {};
                        //this.url="/api/user/Findaudit";
                        _this.data.type = _this.selectType();
                        _this.data.type2 = _this.selectStage();
                        _this.data.uid = authorization.getUserId();
                        _this.data.pageIndex = pageIndex_2;
                        _this.data.name = _this.projectName();
                        _this.data.order = 'big';
                        _this.loadData();
                    });
                });
            }
        }
    };
    // 收购的驳回
    HeaderModel.prototype.shougouBack = function (data) {
        var _this = this;
        if (this.auditStatus() == "4") {
            window.popBox.show("复审同意后不能驳回");
            return;
        }
        if (this.shougouInfo().reason.length > 400) {
            return window.popBox.show('审核意见不能超过400个字符');
        }
        if (this.projectStatus() == "洽谈跟进" && (this.auditStatus() == "0" || this.auditStatus() == "-1" || this.auditStatus() == "-2" || this.auditStatus() == "-3")) {
            window.popBox.show("你已经驳回，无法再次操作");
        }
        else {
            var pageIndex_3 = this.viewModel().data.pageIndex;
            this.shougou(0);
            ajax.post("/api/project/proback", { uid: authorization.getUserId(), pid: this.projectId(), prostatus: this.projectStatus(), content: this.shougouInfo().reason })
                .then(function (d) {
                // 发送数据重新加载数据
                _this.data = {};
                //this.url="/api/user/Findaudit";
                _this.data.type = _this.selectType();
                _this.data.type2 = _this.selectStage();
                _this.data.uid = authorization.getUserId();
                _this.data.name = _this.projectName();
                _this.data.pageIndex = pageIndex_3; // 保存当前页
                _this.data.order = 'big';
                _this.loadData();
            });
        }
    };
    /////全委的审核
    HeaderModel.prototype.quanweiPass = function (data) {
        var _this = this;
        if (this.auditStatus() == "4") {
            window.popBox.show("复审只有一次机会");
            return;
        }
        if (this.quanweiInfo().totalExtract() == 0) {
            this.quanweiInfo().totalExtract(Number(this.quanweiInfo().totalExtract()).toFixed(2));
            console.log('-------新津女子图鉴--------');
        }
        if (this.quanweiInfo().totalExtract() == '') {
            return window.popBox.show('金额不能为空');
        }
        if (Number(this.quanweiInfo().totalExtract()) < 0) {
            return window.popBox.show('金额不能小于0');
        }
        if (Number(this.quanweiInfo().totalExtract()) >= 100000000000000000000) {
            return window.popBox.show('金额过大');
        }
        if (this.quanweiInfo().reason.length > 400) {
            return window.popBox.show("审核意见不能超过400个字符");
        }
        for (var i in this.quanweiInfo().extractList()) {
            var n = this.quanweiInfo().extractList()[i];
            if (n.comment && n.comment.length > 400) {
                return window.popBox.show('备注字符不能超过400');
            }
            if (n.assignRate == '') {
                return window.popBox.show('分配比例不能存在空值');
            }
            if (Number(n.assignRate) < 0) {
                return window.popBox.show('分配比例不能小于0');
            }
        }
        if (this.projectStatus() == "完成") {
            return window.popBox.show("已经审核不能再点击审核");
        }
        else if (this.projectStatus() == "洽谈跟进" && (this.auditStatus() == "0" || this.auditStatus() == "-1" || this.auditStatus() == "-2" || this.auditStatus() == "-3")) {
            return window.popBox.show("业务员还没有上传表单");
        }
        else {
            console.log(this.quanweiInfo());
            if (this.sumOfComputation()) {
                this.quanweiInfo().extractList().map(function (p) { return _this.toJS(p); });
                ajax.post('/api/update/signform', this.toJS(this.quanweiInfo())).then(function () {
                });
                var pageIndex_4 = this.viewModel().data.pageIndex;
                this.projects(this.viewModel());
                this.quanwei(0);
                ajax.post("/api/project/progo", {
                    userId: authorization.getUserId(),
                    projectId: this.projectId(),
                    content: this.quanweiInfo().reason,
                    austatus: this.auditStatus(),
                    projectStatus: this.projectStatus()
                }).then(function (d) {
                    // 发送数据重新加载数据
                    window.popBox.show(d.message).then(function () {
                        _this.data = {};
                        //this.url="/api/user/Findaudit";
                        _this.data.type = _this.selectType();
                        _this.data.type2 = _this.selectStage();
                        _this.data.uid = authorization.getUserId();
                        _this.data.pageIndex = pageIndex_4;
                        _this.data.name = _this.projectName();
                        _this.data.order = 'big';
                        _this.loadData();
                    });
                });
            }
        }
    };
    HeaderModel.prototype.extractListChange = function (num, index) {
        console.log(num);
        var d;
        if (this.formType() == '全委') {
            d = this.quanweiInfo().extractList()[index];
        }
        else {
            d = this.shougouInfo().extractList()[index];
        }
        if (d.assignRate == undefined) {
            return window.popBox.show('分配比例不能为空');
        }
        if (d.assignRate.trim() == '') {
            return window.popBox.show('分配比例不能为空');
        }
        if (Number(d.assignRate) < 0) {
            return window.popBox.show('分配比例不能小于0');
        }
        if (Number(d.assignRate) > 80) {
            return window.popBox.show('单个分配比例不能大于80');
        }
        var c = (Number(num) * Number(d.assignRate) / 100).toFixed(2);
        d.extract(c);
    };
    HeaderModel.prototype.extractListChangePlus = function (num) {
        var d;
        if (this.formType() == '全委') {
            if (this.quanweiInfo().totalExtract() == '') {
                this.quanweiInfo().totalExtract('');
            }
            else {
                this.quanweiInfo().totalExtract(Number(num).toFixed(2));
            }
            d = this.quanweiInfo().extractList();
        }
        else {
            if (this.shougouInfo().totalExtract() == '') {
                this.shougouInfo().totalExtract('');
            }
            else {
                this.shougouInfo().totalExtract(Number(num).toFixed(2));
            }
            d = this.shougouInfo().extractList();
        }
        d.forEach(function (a) {
            var c = (Number(num) * Number(a.assignRate) / 100).toFixed(2);
            a.extract(c);
        });
    };
    HeaderModel.prototype.sumOfComputation = function () {
        if (this.formType() == '全委') {
            if (this.quanweiInfo().extractList().length > 0) {
                var num_1 = 0;
                this.quanweiInfo().extractList().forEach(function (n) { return num_1 += parseInt(n.assignRate); });
                if (num_1 > 80 || num_1 < 80) {
                    window.popBox.show('分配比例不符合规定');
                    return false;
                }
            }
            return true;
        }
        else {
            var num_2 = 0;
            this.shougouInfo().extractList().forEach(function (n) { return num_2 += parseInt(n.assignRate); });
            if (num_2 > 80 || num_2 < 80) {
                window.popBox.show('分配比例不符合规定');
                return false;
            }
            return true;
        }
    };
    // 全委的驳回
    HeaderModel.prototype.quanweiBack = function (data) {
        var _this = this;
        if (this.auditStatus() == "4") {
            window.popBox.show("复审只有一次机会");
            return;
        }
        if (this.quanweiInfo().reason.length > 400) {
            return window.popBox.show("审核意见不能超过400个字符");
        }
        if (this.projectStatus() == "洽谈跟进" && (this.auditStatus() == "0" || this.auditStatus() == "-1" || this.auditStatus() == "-2" || this.auditStatus() == "-3")) {
            window.popBox.show("你已经驳回，无法再次操作");
        }
        else {
            var pageIndex_5 = this.viewModel().data.pageIndex;
            this.quanwei(0);
            ajax.post("/api/project/proback", { uid: authorization.getUserId(), pid: this.projectId(), prostatus: this.projectStatus(), content: this.quanweiInfo().reason })
                .then(function (d) {
                // 发送数据重新加载数据
                _this.data = {};
                // this.url="/api/user/Findaudit";
                _this.data.type = _this.selectType();
                _this.data.type2 = _this.selectStage();
                _this.data.uid = authorization.getUserId();
                _this.data.name = _this.projectName();
                _this.data.pageIndex = pageIndex_5; // 保存当前页
                _this.loadData();
            });
        }
    };
    // 设置定位图片
    HeaderModel.prototype.location = function (m, d) {
        //console.log(d);
        var mapgps;
        setTimeout(function () {
            mapgps = d.haveGPS.split(',');
            var map = new BMap.Map('container');
            map.centerAndZoom(new BMap.Point(mapgps[0], mapgps[1]), 16);
            map.addControl(new BMap.NavigationControl());
            map.addControl(new BMap.ScaleControl());
            map.addControl(new BMap.OverviewMapControl());
            map.addControl(new BMap.MapTypeControl());
            map.enableScrollWheelZoom(true);
            var new_point = new BMap.Point(mapgps[0], mapgps[1]);
            var marker = new BMap.Marker(new_point); // 创建标注
            map.addOverlay(marker); // 将标注添加到地图中
            map.panTo(new_point);
        }, 1000);
    };
    HeaderModel.prototype.loadbubble = function () {
        var arr = [];
        for (var i = 0; i < 7; i++) {
            arr.push(localStorage.getItem(i.toString()));
        }
        return ajax.post('/api/statistics/smessage', { userId: authorization.getUserId(), time: arr }).then(function (d) {
            ko.postbox.publish('leftMenu_myProject', d.data.count0);
            ko.postbox.publish('leftMenu_myFollowProject', d.data.count1);
            ko.postbox.publish('leftMenu_noFollowNews', d.data.count2);
            ko.postbox.publish('leftMenu_waitProjectNews', d.data.count3);
            ko.postbox.publish('leftMenu_signgedProjectNews', d.data.count4);
            ko.postbox.publish('leftMenu_abandonProjectNews', d.data.count5);
            ko.postbox.publish('leftMenu_auditMessage', d.data.count6);
        });
    };
    HeaderModel.prototype.loadnum = function () {
        this.chatLog(false);
        return ajax.get('/api/statistics/message', { userid: authorization.getUserId(), loginTime: new Date()["Format"]('yyyy-MM-dd hh:mm:ss') }).then(function (d) {
            ko.postbox.publish('leftMenu_allProject', d.data.allProject);
            ko.postbox.publish('leftMenu_followProject', d.data.followProject);
            ko.postbox.publish('leftMenu_nofollow', d.data.nofollow);
            ko.postbox.publish('leftMenu_waitProject', d.data.waitProject);
            ko.postbox.publish('leftMenu_signgedProject', d.data.signgedProject);
            ko.postbox.publish('leftMenu_abandonProject', d.data.abandonProject);
            ko.postbox.publish('leftMenu_noReadProject', d.data.noReadProject);
        });
    };
    HeaderModel.prototype.load = function () {
        var _this = this;
        return Promise.all([this.loadnum(), this.loadbubble(), this.loadData().then(function (d) {
                //console.log(d.data.list);
                if (_this.viewModel().data == "") {
                    _this.showData(0);
                }
                else {
                    _this.showData(1);
                }
                _this.projects(_this.viewModel());
            }).catch(function (e) {
                //console.log("初始化失败");
            })]).then(function () { });
    };
    return HeaderModel;
}(KnockoutModel));
var mModel = /** @class */ (function (_super) {
    __extends(mModel, _super);
    function mModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    mModel.prototype.init = function () {
        this.hm = new HeaderModel(this.container);
        //this.hm.bind();
    };
    mModel.prototype.update = function (arg) {
        this.hm.userId(authorization.getUserId());
        this.hm.projectName('');
        ajax.post('/api/log/add', { userId: authorization.getUserId(), logMessage: "项目督导" });
        ajax.get("/api/menu/projectNotice", { uid: authorization.getUserId() });
        //this.hm.reason('');
        this.hm.selectType('全部');
        this.hm.selectStage('全部');
        if (arg.routeData.query.type) {
            this.hm.isNoShow(true);
        }
        else {
            this.hm.isNoShow(false);
        }
        this.hm.data = {};
        //this.hm.url="/api/user/Findaudit";
        this.hm.id = null;
        this.hm.data.type = '全部';
        this.hm.data.type2 = '全部';
        this.hm.data.uid = authorization.getUserId();
        this.hm.data.pageIndex = 1;
        this.hm.data.projectName = this.hm.projectName();
        this.hm.data.order = '';
        return this.hm.load();
    };
    mModel.prototype.onInitComplete = function () {
    };
    return mModel;
}(Page));
export default mModel;
